import React from 'react';
import { Alert, Box, Button, Stack, Typography } from '@mui/material';

interface WaitingForAssignmentPanelProps {
  submitting: boolean;
}

const WaitingForAssignmentPanel: React.FC<WaitingForAssignmentPanelProps> = ({ submitting }) => {
  return (
    <Alert
      severity="info"
      sx={{
        borderWidth: 2,
        borderStyle: 'solid',
        borderColor: '#1976d2',
        '& .MuiAlert-message': { width: '100%' }
      }}
    >
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
          You're checked in and ready to trade.
        </Typography>
        <Typography variant="body2">
          Wait here while the event organizer assigns your trade location. Once your table is ready, come back to this screen to continue your trade.
        </Typography>
        <Box>
          <Button variant="contained" onClick={() => window.location.reload()} disabled={submitting}>
            Refresh Trade Status
          </Button>
        </Box>
      </Stack>
    </Alert>
  );
};

export default WaitingForAssignmentPanel;
